// -----------------------------------------------------------------------------
// <copyright file="roles-permissions.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>

export enum Role {
  Approver = 'Approver',
  Creator = 'Creator',
  WarehouseUser = 'WarehouseUser',
  FGMaintainance = 'FGMaintainance',
  FGApprover = 'FGApprover',
  WIViewer = 'WIViewer',
  WIMaintenance = 'WIMaintenance',
  WIApprover = 'Approver',
  ConfiguratorUser = 'ConfiguratorUser',
  ConfiguratorAdmin = 'ConfiguratorAdmin'
}

export const RoleLabel = {
  Approver: 'WI Approver',
  Creator: 'Creator',
  WarehouseUser: 'Warehouse User',
  FGMaintainance: 'FG Maintainance',
  FGApprover: 'FG Approver',
  WIViewer: 'WI Viewer',
  WIMaintenance : 'WI Maintenance',
  WIApprover : 'WI Approver',
  ConfiguratorUser : 'Configurator User',
  ConfiguratorAdmin : 'Configurator Admin'
};

export const Permissions = {
  FinishedGoodsTab: {
    VIEW: [Role.FGApprover],
    CREATE : [Role.FGApprover],
    VIEW_UNDER_DEV_FG : [Role.FGApprover],
    VIEW_PROD_FG : [Role.FGApprover],
    EDIT_UNDER_DEV_FG : [Role.FGApprover],
    SUBMIT : [Role.FGApprover],
    EDIT_PROD_FG : [Role.FGApprover],
    ATTACH_DELETE_DOC : [Role.FGApprover],
    DELETE_FG : [Role.FGApprover],
    DUPLICATE_FG : [Role.FGApprover],
    CHANGE_BOM_TYPE : [Role.FGApprover]
  },

  WorkInstructionTab: {
    VIEW: [Role.WIApprover],
    CREATE : [Role.WIApprover],
    VIEW_UNDER_DEV_WI : [Role.WIApprover],
    VIEW_PROD_WI : [Role.WIApprover],
    EDIT_UNDER_DEV_WI : [Role.WIApprover],
    VIEW_SO_LINK : [Role.WIApprover],
    SUBMIT : [Role.WIApprover],
    ATTACH_DELETE_DOC: [Role.WIApprover],
    GENERATE_SO : [Role.WIApprover],
    DELETE : [Role.WIApprover],
    DUPLICATE : [Role.WIApprover],
    VIEW_LINK_WI : [Role.FGApprover]
  },

  GenerateUrls: {
    view: [Role.Approver, Role.Creator],
    create: [Role.Approver, Role.Creator],
  },

  SalesOrder: {
    VIEW: [Role.WarehouseUser],
    EDIT : [Role.WarehouseUser],
    SIGN_OFF : [Role.WarehouseUser]
  },
};
